import * as React from "react";
import { cn } from "@/lib/utils";

interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: React.ReactNode;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, label, id, ...props }, ref) => {
    return (
      <label className="relative inline-flex items-center cursor-pointer gap-2">
        <input
          type="checkbox"
          ref={ref}
          id={id}
          className="sr-only peer"
          {...props}
        />
        <div
          className={cn(
            "w-9 h-5 rounded-full bg-active transition-colors duration-150 ease-out peer peer-checked:bg-primary peer-focus-visible:ring-[3px] peer-focus-visible:ring-ring/30 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed",
            "peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:shadow-sm after:transition-transform after:duration-150 after:ease-out",
            className
          )}
        />
        {label && (
          <span className="text-sm text-muted-foreground">{label}</span>
        )}
      </label>
    );
  }
);
Switch.displayName = "Switch";
